import { Button, Card, CardContent } from "@material-ui/core";
import ElementsDataGridPro from "../../../../utils/DataGrid/ElementsDataGridPro";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { selectHousingPeriod, selectProcessAppliationsPermissions, selectRoomAssignmentPermissions, selectSearchHousingPeriodsResults } from "../../../../redux/student-life-page/housing-periods/housingPeriodsSelectors";
import { useDispatch, useSelector } from "react-redux";
import { TextInput, SelectInput } from "../../../../components/Forms";
import { useFormik } from "formik";
import { clearHousingPeriod, searchHousingPeriodRoomAssignments, setHousingPeriodApplicationBasicDetails } from "../../../../redux/student-life-page/housing-periods/housingPeriodsActions";
import { ButtonWrapperFilter, FormGroup, Splitter, useStyles } from "../../../../styles/common-styles";
import { getApi } from "../../../../services/apiBase";
import { formsAPIs } from "../../../../services/apiURL";
import { Divider, Typography } from "@mui/material";
import Formdialog from "../../../tools-page/forms/components/formdialog";
import { navigateToNextStep, getPropertiesForHousingPeriod } from "../../../../redux/student-life-page/housing-room-search/housingRoomSearchActions";
import { ASSIGN_ROOM } from "../housing-periods/housingPeriodConstants";
import { AccessLevel } from "../../../../helper/constants";

export const HousingPeriodRoomAssignmentGrid = () => {

    const { housingPeriodID } = useSelector(selectHousingPeriod);

    // Labels
    const { programs, housingApplications, campuses, residentialStatus } = useSelector((state) => state.housingPeriods.selectItems);
    
    const { t } = useTranslation(["studentLife"]);
    const applicationNameLabel = t("housingPeriods.processapplication.search.applicationName", { ns: "studentLife" });
    const studentId = t("housingPeriods.processapplication.search.studentId", { ns: "studentLife" })

    const searchButtonLabel = t("buttonLabel.search");
    const cancelButtonLabel = t("buttonLabel.cancel");
    const nextButtonLabel = t("buttonLabel.next");
    const resetButtonLabel = t("buttonLabel.reset");

    const residentialStatusLabel = t("housingPeriods.processapplication.search.residentialStatus", { ns: "studentLife" })
    const residentialTypeLabel = t("housingPeriods.processapplication.search.residentialType", { ns: "studentLife" })
    const campusLabel = t("housingPeriods.processapplication.search.campus", { ns: "studentLife" });
    const firstNameLabel = t("housingPeriods.processapplication.search.firstName", { ns: "studentLife" });
    const lastNameLabel = t("housingPeriods.processapplication.search.lastName", { ns: "studentLife" });
    const programLabel = t("housingPeriods.processapplication.search.program", { ns: "studentLife" })
    const propertyLabel = t("housingPeriods.processapplication.search.property", { ns: "studentLife" })
    const roomAssignedLabel = t("housingPeriods.processapplication.search.roomAssigned", { ns: "studentLife" })
    const ageLabel = t("housingPeriods.processapplication.search.age", { ns: "studentLife" });
    const selectOneLabel = t("housingPeriods.addEditWizard.basicDetails.selectOneLabel", { ns: "studentLife" });
    const searchResultsTitle = t("housingPeriods.roomAssignment.results", { ns: "studentLife" });

    useEffect(() => {
        dispatch(searchHousingPeriodRoomAssignments(getPayload()));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const resetForm = async () => {
        formik.resetForm();
        dispatch(searchHousingPeriodRoomAssignments(getPayload()));
    }

    const classes = useStyles();

    const isLoading = useSelector((state) => state.housingPeriods.search.isLoading);

    const accessLevel = useSelector(selectRoomAssignmentPermissions);
    const [selectedRows, setSelectedRows] = useState([]);
    const processApplicationAccess = useSelector(selectProcessAppliationsPermissions);
    const housingPeriodProperties = useSelector((state) => state.housingRoomSearch.searchSelectItems.housingPeriodProperties);
    
    const dispatch = useDispatch();
    const [responseDialogElement, setCloseResponseDialog] = useState(null);
    const [formJson, setFormJson] = useState(null);
    const [response, setResponse] = useState(null);
    const [userInfo, setUserInfo] = useState({});

    const viewResponse = Boolean(responseDialogElement);
    let superUser = localStorage.getItem('superUser')
    let campusID = localStorage.getItem('campusID')

    useEffect(() => {

        // Fetch the housing period properties for the currently-selected housing period
        dispatch(getPropertiesForHousingPeriod(housingPeriodID));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const residentialStatusWithEmptyValue = [
        { uniqueId: '-1', displayText: selectOneLabel, isSelected: false },
        ...residentialStatus
    ];

    const campusesWithEmptyValue = [
        { uniqueId: '-1', displayText: selectOneLabel, isSelected: false }, 
        ...campuses.filter(c => c.displayText !== '')
    ]

    const propertiesWithEmptyValue = [
        { uniqueId: '-1', displayText: selectOneLabel, isSelected: false },
        ...housingPeriodProperties
    ];

    const roomAssignedDropdown = [
        { displayText: "Yes", uniqueId: true },
        { displayText: "No", uniqueId: false }
    ]

    const defaultCriteria = {
        residentialStatusID: '1',
        "campusId": (superUser === 'N') ? Number(campusID) : "0",
        housingPeriodID: housingPeriodID,
        properties: '-1',
        property: '-1',
        residentStatusId: '-1',
        formID: housingApplications ? housingApplications[0]?.id : undefined,
        roomAssigned: false,
        programId: '0',
        ageOperator: ''
    };

    const getPayload = () => {
        return{
        housingPeriodID: housingPeriodID,
        formID: formik.values.formID,
        applicationStatusID: formik.values.applicationStatusId,
        residentStatusID: formik.values.residentStatusId === '-1' ? undefined : formik.values.residentStatusId,
        campusID: formik.values.campusId === '-1' ? undefined : formik.values.campusId,
        programID: formik.values.programId === '0' ? undefined : formik.values.programId,
        property: formik.values.property === '-1' ? undefined : formik.values.property,
        ageOperator: formik.values.ageOperator,
        age: !formik.values.age ? null : formik.values.ageOperator !== "Between" ? [formik.values.age] : [formik.values.ageLowerLimit, formik.values.ageUpperLimit],
        roomAssigned: formik.values.roomAssigned
        };
    };
    const formik = useFormik({
        initialValues: defaultCriteria,
        enableReinitialize: true,
        onSubmit: () => {
            dispatch(searchHousingPeriodRoomAssignments(getPayload()));
        }
    });

    const arithmeticDropdown = [
        {
            "uniqueId": "Equal",
            "displayText": "=",
            "isSelected": false
        }
        ,
        {
            "uniqueId": "GreaterThan",
            "displayText": ">",
            "isSelected": false
        }
        ,
        {
            "uniqueId": "LessThan",
            "displayText": "<",
            "isSelected": false
        }
        ,
        {
            "uniqueId": "GreaterThanOrEqual",
            "displayText": ">=",
            "isSelected": false
        }
        ,
        {
            "uniqueId": "LessThanOrEqual",
            "displayText": "<=",
            "isSelected": false
        }
        ,
        {
            "uniqueId": "Between",
            "displayText": "Between",
            "isSelected": true
        }
    ];

    const housingRoomAssignmentColumns = [
        { id: "applicationName", label: applicationNameLabel },
        { id: "lastName", label: lastNameLabel },
        { id: "firstName", label: firstNameLabel },
        { id: "studentId", label: studentId },
        { id: "residentType", label: residentialTypeLabel },
        { id: "roomAssigned", label: roomAssignedLabel },
        { id: "residentStatus", label: residentialStatusLabel },
    ];

    const housingPeriodApprovedApplications = useSelector(selectSearchHousingPeriodsResults);
    const dialogTitle = `${t("formLabels.responderId", { ns: "tools" })}: ${userInfo?.studentID}`;

    const closeResponseDialog = () => {
        setCloseResponseDialog(null);
    }

    const viewResponseDialog = (selectedRow) => {

        const formUID = selectedRow.formUID;
        const responseId = selectedRow.responseId;
        setUserInfo({ firstName: selectedRow.firstName, lastName: selectedRow.lastName, studentID: selectedRow.studentId })

        getApi(`${formsAPIs.get}/${formUID}`)
            .then(response => {
                if (response.data.isSuccess) {
                    setFormJson(JSON.parse(response.data.data.formQuestionsJson));
                }
            })


        getApi(`${formsAPIs.response}/${formUID}/${responseId}`)
            .then(response => {
                if (response.data.isSuccess) {
                    setResponse(response.data.data);
                }
            })

        setCloseResponseDialog(response !== undefined);
    }

    const initialState = {
        sorting: {
            sortModel: [
                { field: 'applicationName', sort: 'asc' },
                { field: 'applicationStatus', sort: 'asc' }
            ]
        },
        columns: {
            columnVisibilityModel: {
                residentType: true,
            },
        },
    }

    const handleCancelClick = () => {
        dispatch(clearHousingPeriod());
    }

    const handleNextClicked = () => {
        if (selectedRows.length > 0) {
            dispatch(setHousingPeriodApplicationBasicDetails(selectedRows[0]));
            dispatch(navigateToNextStep(ASSIGN_ROOM));
        }
    }

    return (
        <>
            <Card className={classes.root}>
                <CardContent>
                    <Typography component="h3" variant="h7" style={{ marginBottom: "10px", fontSize: "larger" }}>{t("housingPeriods.assignSearchpageTitle")}</Typography>
                    <br />
                    <form onSubmit={formik.handleSubmit} autoComplete="off">
                        <FormGroup>
                            <SelectInput labelId={"formID"}
                                label={applicationNameLabel}
                                mandatory={true}
                                aria-label={applicationNameLabel}
                                formikValue={formik.values.formID}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "applicationName", value: 'id', optionLists: housingApplications }}
                                onTooltip={t('roomAssignmentTooltip.applicationName')}
                            />
                            <SelectInput labelId={"residentStatusId"}
                                label={residentialStatusLabel}
                                aria-label={residentialStatusLabel}
                                formikValue={formik.values.residentStatusId}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: residentialStatusWithEmptyValue }}
                            />
                            <SelectInput labelId={"campusId"}
                                label={campusLabel}
                                aria-label={campusLabel}
                                formikValue={formik.values.campusId}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: campusesWithEmptyValue }}
                                onTooltip={t('roomAssignmentTooltip.campus')}
                            />
                            <SelectInput labelId={"programId"}
                                label={programLabel}
                                aria-label={programLabel}
                                formikValue={formik.values.programId}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: programs }}
                                onTooltip={t('roomAssignmentTooltip.program')}
                            />
                        </FormGroup>
                        <FormGroup>
                            <SelectInput
                                labelId={"property"}
                                label={propertyLabel}
                                aria-label={propertyLabel}
                                formikValue={formik.values.property}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: propertiesWithEmptyValue }}
                                onTooltip={t('roomAssignmentTooltip.property')}
                            />
                            <SelectInput
                                label={ageLabel}
                                labelId={"ageOperator"}
                                customStyle={{
                                    width: "12.5%",
                                }}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: arithmeticDropdown }}
                                formikValue={formik.values.ageOperator}
                                formikChange={formik.handleChange}
                                onTooltip={t('roomAssignmentTooltip.ageOperator')}
                         
                            />
                            {formik.values.ageOperator !== "Between" ?
                                <TextInput
                                    onlyNumberDigits
                                    labelId={"age"}
                                    customStyle={{
                                        width: '10%',

                                    }}
                                    errors={formik.errors.age}
                                    touched={formik.touched.age}
                                    formikValue={formik.values.age}
                                    formikChange={formik.handleChange}
                                    maxlength={5}
                                    onTooltip={t('roomTooltip.age')}
                                />
                                : <>
                                    <TextInput
                                        onlyNumberDigits
                                        labelId={"ageLowerLimit"}
                                        customStyle={{
                                            width: "4%",
                                        }}

                                        errors={formik.errors.ageLowerLimit}
                                        touched={formik.errors.ageLowerLimit}
                                        formikValue={formik.errors.ageLowerLimit}
                                        formikChange={formik.handleChange}
                                        maxlength={5}
                                        onTooltip={t('roomTooltip.ageLowerLimit')}
                                    />
                                    <TextInput
                                        onlyNumberDigits
                                        labelId={"ageUpperLimit"}
                                        customStyle={{
                                            width: "4%",
                                        }}
                                        errors={formik.errors.ageUpperLimit}
                                        touched={formik.touched.ageUpperLimit}
                                        formikValue={formik.values.ageUpperLimit}
                                        formikChange={formik.handleChange}
                                        maxlength={5}
                                        onTooltip={t('roomTooltip.ageUpperLimit')}
                                    /></>

                            }
                            <SelectInput
                                labelId={"roomAssigned"}
                                label={roomAssignedLabel}
                                aria-label={roomAssignedLabel}
                                formikValue={formik.values.roomAssigned}
                                formikChange={formik.handleChange}
                                dropdownData={{ key: "displayText", value: 'uniqueId', optionLists: roomAssignedDropdown }}
                                onTooltip={t('roomAssignmentTooltip.roomAssigned')}
                            />
                        </FormGroup>
                        <ButtonWrapperFilter>
                            <Button
                                className="BgYellowOrange search"
                                variant="contained"
                                size="large"
                                type="submit"
                                aria-label={searchButtonLabel}
                            >
                                {searchButtonLabel}
                            </Button>
                            <Button
                                className="BgLightBlue search"
                                variant="contained"
                                size="large"
                                type="reset"
                                aria-label={resetButtonLabel}
                                onClick={resetForm}
                            >
                                {resetButtonLabel}
                            </Button>
                        </ButtonWrapperFilter>
                    </form>
                </CardContent>
                <Splitter height="20px" />
                <Divider />
                <Splitter height="20px" />
                <CardContent>
                    <Typography component="h3" variant="h7" style={{ marginBottom: "10px", fontSize: "larger" }}>{searchResultsTitle}</Typography>
                    <ElementsDataGridPro
                        defaultColumns={{ residentType: false }}
                        trackingLabel={"housingPeriodsAssignRoomsTable"}
                        headCells={housingRoomAssignmentColumns}
                        rows={housingPeriodApprovedApplications}
                        onView={viewResponseDialog}
                        isLookup={false}
                        isLoading={isLoading}
                        pagination={housingPeriodApprovedApplications.length > 0}
                        dataGridToolbar={true}
                        dataGridColumnMenus={true}
                        hideFooterSelectedRowCount={true}
                        initialSorting={initialState}
                        addEditAccess={accessLevel === 2}
                        viewAccess={accessLevel >= 1}
                        multiSelect={false}
                        moreActionsAccess = { selectedRows.length >0 && accessLevel=== AccessLevel.ReadWrite &&  processApplicationAccess >=1}
                        columnVisibilityModel={initialState.columns.columnVisibilityModel}
                        selectionModelChanged={(rows)=>setSelectedRows(rows)}
                       
                    />
                    <br />
                    <ButtonWrapperFilter>
                        <Button
                            className="BgLightBlue search"
                            variant="contained"
                            size="large"
                            type="reset"
                            aria-label={cancelButtonLabel}
                            onClick={handleCancelClick}
                        >
                            {cancelButtonLabel}
                        </Button>
                        <Button
                            className="BgYellowOrange search"
                            variant="contained"
                            size="large"
                            aria-label={nextButtonLabel}
                            type="reset"
                            disabled={selectedRows.length === 0 && selectedRows.length <= 0}
                            onClick={handleNextClicked}
                        >
                            {nextButtonLabel}
                        </Button>
                    </ButtonWrapperFilter>
                </CardContent>
            </Card>

            {viewResponse && <Formdialog open={viewResponse} onClose={closeResponseDialog} formData={{ jsonObj: formJson, formResult: response }} dialogTitle={dialogTitle} />}
        </>
    );


}